import { render } from "./SizingRow.vue?vue&type=template&id=08ab573f"
import script from "./SizingRow.vue?vue&type=script&lang=js"
export * from "./SizingRow.vue?vue&type=script&lang=js"

import exportComponent from "/Users/sjoshi6/git/openmct/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__